import type { Components } from '@mui/material/styles';

export default function MuiAlertTitle(): Components['MuiAlertTitle'] {
  return {};
}
